export default __webpack_public_path__ + "static/media/UserGuide_it_IT.18219e0d.pdf";